import { lazy } from "react";

export const TheHousingHubLayouts = { layout1: lazy(() => import("./Layout1/Layout1")) };
